import { FiberManualRecord } from '@mui/icons-material';
import { Checkbox, Grid, styled, TableCell } from '@mui/material';

const colors = ['red', 'orange', 'blue', 'green', 'purple', 'pink', 'brown'];

export const GridActionsWrapper = styled(Grid, { shouldForwardProp: prop => !['horizontalSpacing'].includes(prop) })(
  ({ theme, horizontalSpacing = false }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    marginInline: horizontalSpacing ? theme.spacing(1) : 0
  })
);

export const PaymentPlanTableCell = styled(TableCell)(({ theme }) => ({
  textAlign: 'center',
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1),
  '& .MuiFormControlLabel-root': {
    margin: 0
  }
}));

export const CalendarTableCell = styled(PaymentPlanTableCell)(({ theme }) => ({
  padding: `${theme.spacing(1.5)} ${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)}`,
  borderRight: '1px solid lightgrey',
  height: theme.spacing(11),
  minHeight: theme.spacing(11),
  maxHeight: theme.spacing(11)
}));

export const CalendarCheckbox = styled(Checkbox)(() => ({
  margin: 0,
  padding: 0
}));

export const ColoredCircle = styled(FiberManualRecord, { shouldForwardProp: prop => !['colorIndex'].includes(prop) })(
  ({ theme, colorIndex }) => ({
    fontSize: theme.spacing(2),
    color: colors[colorIndex]
  })
);

export const CalendarOptionsWarning = styled(Grid)(({ theme }) => ({
  background: theme.palette.warning.main,
  color: theme.palette.white.main,
  borderRadius: theme.spacing(1)
}));

export const CalendarOptionRow = styled(Grid)(({ theme }) => ({
  border: '1px solid lightgrey',
  borderRadius: theme.spacing(1)
}));

export const NoCalendarOptionsContainer = styled(Grid)(({ theme }) => ({
  border: '2px dashed grey',
  borderRadius: theme.spacing(1)
}));
